import React from 'react';
import clsx from "clsx";

import './BoxWave.scss';

const BoxWave = (props) => {
    return (
        <div className={clsx('box-wave', props.className && `${props.className}`, props.isBig && 'box-wave-big')}>
            {props.children}
        </div>
    );
};

export default BoxWave;